import type { IssuesQuery } from 'shared/domain/issue/issueQuery';
import { groupOf } from 'shared/filter/filterTree';
import { FILTER_LOGICAL_OPERATOR, FILTER_TYPE } from 'shared/filter/types';
import type { LabelledEntity } from 'shared/types/commonView';

/**
 * Issues on the given levels with the grid's filters and archived switch
 * (the map ignores the grid's search, sort and page).
 */
export function buildIssuesOnMapQuery(levels: LabelledEntity[], gridQuery: IssuesQuery): IssuesQuery {
  return {
    // The grid's filters as a whole, joined by its own operator: an OR of the grid must not drop the levels.
    filter: groupOf(FILTER_LOGICAL_OPERATOR.AND, [
      { path: 'primaryData.level', type: FILTER_TYPE.direct, value: levels },
      gridQuery.filter,
    ]),
    search: [],
    archived: gridQuery.archived,
    timezone: gridQuery.timezone,
  };
}
